<template>
  <div class="loading-wrapper">
    <Loader />
    <p>Ładowanie...</p>
  </div>
</template>

<script>
import Loader from '@/components/Loader.vue';

export default {
  name: "LoadingModal",
  components: {
    Loader
  }
};
</script>

<style lang="scss" scoped>

.loading-wrapper {
  width: 50vw;
  height: 50vh;
}

</style>
